@if (participant) {
  <button
    [class.participant--active]="isSelected"
    class="participant"
    (click)="onSelectParticipant()"
    >
    <mat-icon
      class="participant__image"
      [svgIcon]="imageSrc"
      data-testid="participant-image"
    ></mat-icon>
    <div class="participant__details">
      <h3 class="participant__name" data-private>{{ participant.displayName }}</h3>
      <span class="participant__role">{{ getPackageUserRole(participant.userRoleCode) }}</span>
    </div>
  </button>
}
